import SectionHeading from '@/components/feature/SectionHeading';
import { testimonials } from '@/mocks/gossip';

export default function TestimonialSection() {
  return (
    <section className="bg-secondary-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8">
        <SectionHeading
          eyebrow="读者口碑"
          title="一直在看的人，是怎么说的"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-secondary-200 bg-background-50 p-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600">
                <i className="ri-double-quotes-l" aria-hidden="true"></i>
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700 md:text-base">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 border-t border-background-200 pt-4">
                <p className="font-heading text-base font-semibold text-foreground-950">{item.name}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{item.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}